import { StowageInstructionDto } from '@planning/app/api'
import { FieldStore, FormStore, required, validateSubForm } from '@tom-ui/utils'

export interface StowageInstructionSubFormType extends StowageInstructionDto {
  hasStowageInstruction?: boolean
}

export class StowageInstructionSubFormStore extends FormStore<StowageInstructionSubFormType> {
  hasStowageInstruction: FieldStore<boolean>
  stowageInstruction: FieldStore<StowageInstructionDto | null | undefined>

  constructor(initialValues?: StowageInstructionDto | null) {
    super()
    this.hasStowageInstruction = new FieldStore<boolean>(initialValues ? true : false)
    this.stowageInstruction = new FieldStore<StowageInstructionDto | null | undefined>(
      initialValues,
      required(),
    )
  }

  validate = () => {
    if (!this.hasStowageInstruction.value) return true
    return validateSubForm(this)
  }

  get data(): StowageInstructionSubFormType {
    if (!this.hasStowageInstruction.value || !this.stowageInstruction.data)
      return { hasStowageInstruction: false, id: 0, name: '' }

    return {
      ...this.stowageInstruction.data,
      hasStowageInstruction: this.hasStowageInstruction.data,
    }
  }
}
